export enum StepDisabledStates {
    disabled = 'disabled',
    enabled = 'enabled'
}

export enum StepVisibilityStates {
    visible = 'visible',
    hidden = 'hidden'
}

export enum StepValidityStates {
    valid = 'valid',
    invalid = 'invalid'
}

export enum StepTouchedStates {
    touched = 'touched',
    untouched = 'untouched'
}

export abstract class StepIndicatorItemViewModel<TStep extends string> {
    public readonly stepId: TStep;

    public readonly title: string;

    public readonly visibility: StepVisibilityStates;
    public readonly isVisible: boolean;

    public readonly disabledState: StepDisabledStates;
    public readonly isDisabled: boolean;

    public readonly validity: StepValidityStates;
    public readonly isValid: boolean;

    public readonly touchedState: StepTouchedStates;
    public readonly isTouched: boolean;

    public readonly isCheckmarkVisible: boolean;
    public readonly isCrossVisible: boolean;

    constructor(
        stepId: TStep,
        title: string,
        visibility: StepVisibilityStates = StepVisibilityStates.visible,
        disabledState: StepDisabledStates = StepDisabledStates.disabled,
        validity: StepValidityStates = StepValidityStates.invalid,
        touchedState: StepTouchedStates = StepTouchedStates.untouched
    ) {
        this.stepId = stepId;
        this.title = title;

        this.visibility = visibility;
        this.isVisible = visibility === StepVisibilityStates.visible;

        this.disabledState = disabledState;
        this.isDisabled = disabledState === StepDisabledStates.disabled;

        this.validity = validity;
        this.isValid = validity === StepValidityStates.valid;

        this.touchedState = touchedState;
        this.isTouched = touchedState === StepTouchedStates.touched;

        this.isCheckmarkVisible =
            this.isValid && this.isTouched && !this.isDisabled;
        this.isCrossVisible =
            !this.isValid && this.isTouched && !this.isDisabled;
    }
}
